export default "__VITE_ASSET__BgH53saW__"